import styled from 'styled-components';
import { Button } from '../../utils/Button/Button';

export const Form = styled.form`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 3rem;

  @media only screen and (max-width: 600px) {
    width: unset;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 1.4rem;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
`;

export const DeleteButton = styled(Button)`
  border: 1px solid #d92d20;
  background: #fff;
  width: unset;
  padding-inline: 2.4rem;
  color: #d92d20;
`;

export const SubmitButton = styled(Button)`
  width: 16rem;
`;

export const MediaContainer = styled.div`
  border-radius: 12px;
  border: 1px solid #f3f4f6;
  width: 100%;
  padding: 0.8rem;
  position: relative;
  display: flex;
`;

export const MediaContentContainer = styled.div`
  min-width: 18rem;
  max-width: 18rem;
  height: 20rem;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f3f4f6;

  div:first-child {
    height: 100%;
  }

  img,
  video {
    object-fit: cover;
  }
`;

export const Content = styled.div`
  width: 100%;
  margin-left: 0.4rem;
  padding: 0 0.4rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const PriceContainer = styled.div`
  display: flex;
  gap: 2rem;
  width: 100%;
  align-items: center;
  min-height: 6.9rem;
`;

export const SellWithAiContainer = styled.div`
  height: 100%;
`;
